import React from 'react'
import { classes, style as _style } from 'typestyle'
import { useParams } from 'react-router-dom'

/* Common ======================================================================================= */
import { formatDate } from '../../../../share/format'

/* Hooks ======================================================================================== */
import useFetch from '../../../../hooks/use-fetch'

/* Components =================================================================================== */
import { Box } from '../../../../components/box/box.component'
import { Button } from '../../../../components/button'
import { Text } from '../../../../components/text/text.component'
import { Line } from '../../../../components/line'
import { Dropdown } from '../../../../components/dropdown'
import { Circle } from '../../../../components/circle'
import { Notification as TNotification } from '../../../../types'

/* Styles ======================================================================================= */
import { f18i } from '../../../../styles/styleset/font-size/f18i'
import { mr8 } from '../../../../styles/styleset/margin/mr8'
import { p4 } from '../../../../styles/styleset/padding/p4'
import { pb12i } from '../../../../styles/styleset/padding/pb12i'
import { pl16 } from '../../../../styles/styleset/padding/pl16'
import { pr16 } from '../../../../styles/styleset/padding/pr16'
import { pt12i } from '../../../../styles/styleset/padding/pt12i'
import { w100 } from '../../../../styles/styleset/width/w100'
import { f14i } from '../../../../styles/styleset/font-size/f14i'
import { mr4 } from '../../../../styles/styleset/margin/mr4'
import { ml4 } from '../../../../styles/styleset/margin/ml4'

export const ActionItem = (props: {
  actionItem: TNotification
  onUpdate?: (item: TNotification) => void
}) => {
  const { actionItem, onUpdate } = props
  const { groupId } = useParams()

  const isLate = new Date(actionItem.body.requiredBy || '') < new Date()
  const url = `${process.env.REACT_APP_API_URL}/a/groups/${groupId}/base/notifications/table/${actionItem.id}`
  const [, $update] = useFetch()

  const handleRead = async () => {
    const item = await $update.patch({
      body: {
        body: {
          read: !actionItem.body.read,
        },
      },
      url,
    })
    onUpdate?.(item)
  }

  return (
    <Box baseline="none" row>
      <Box
        className={classes(pb12i, pt12i, pl16, pr16)}
        baseline="none"
        flex
        fullWidth
        alignCenterY
      >
        <Box alignCenterY style={{ flex: 1 }}>
          <Circle
            baseline={isLate ? 'error' : actionItem.body.read ? 'background' : 'primary'}
            className={classes(mr8, _style({ width: '8px', height: '8px' }))}
          />
          <Circle baseline="background" className={mr8} size="lg">
            <Text uppercase semiBold size="sm">
              {(actionItem.body.by as any)?.body?.initials}
            </Text>
          </Circle>
          <Box baseline="none" row alignCenterY style={{ flex: 1 }}>
            <Box row>
              <Text semiBold size="sm">
                {(actionItem.body.by as any)?.body?.fullName}
              </Text>
              <Text baseline="surface" size="sm" lighter shrink>
                {formatDate(actionItem.createdAt.toString(), { time: true })}
              </Text>
            </Box>
            <Box flex alignCenterY>
              {actionItem.body.breadcrumbs?.map((breadcrumb, idx) => {
                return (
                  <Box flex alignCenterY key={`actionItem-${actionItem.id}-breadcrumb-${idx}`}>
                    <a href={breadcrumb.to}>
                      <Text sublink size="xs" className={classes(_style({ display: 'block' }))}>
                        {breadcrumb.label}
                      </Text>
                    </a>
                    {idx < (actionItem.body.breadcrumbs?.length || 0) - 1 ? (
                      <Box className={classes(ml4, mr4)}>
                        <span
                          className={classes(
                            'material-icons-two-tone',
                            f14i,
                            _style({ display: 'block !important' }),
                          )}
                        >
                          keyboard_arrow_right
                        </span>
                      </Box>
                    ) : (
                      ''
                    )}
                  </Box>
                )
              })}
            </Box>
            <Text size="sm">
              <div dangerouslySetInnerHTML={{ __html: actionItem.body.message }} />
            </Text>
            {actionItem.body.requiredBy && (
              <Text baseline="surface" size="sm">
                Required By:
                <Text baseline={isLate ? 'error' : 'surface'} bold size="sm">
                  {formatDate(actionItem.body.requiredBy.toString(), {
                    time: true,
                  })}
                </Text>
              </Text>
            )}
          </Box>
        </Box>
        <Box flex alignCenterY>
          <Dropdown
            floatProps={{
              anchorPosition: 'bottom right',
              dialogPosition: 'top right',
              width: 'fit-content',
              flip: true,
            }}
          >
            <Button
              size="sm"
              baseline="none"
              icon={<span className={classes('material-icons', f18i)}>more_horiz</span>}
            />
            {(close: any) => {
              return (
                <Box
                  baseline="surface"
                  className={classes(p4, _style({ width: 'fit-content' }))}
                  rounded
                  shadow
                  flex
                  row
                >
                  <Button
                    className={classes(w100)}
                    baseline="surface"
                    label={actionItem.body.read ? 'Mark Incomplete' : 'Mark Complete'}
                    size="sm"
                    center={false}
                    square
                    onClick={handleRead}
                  />
                </Box>
              )
            }}
          </Dropdown>
        </Box>
      </Box>
      <Line />
    </Box>
  )
}
